var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './search.component.less';
import { forEach } from 'lodash';
import { Stratus } from '@stratusjs/runtime/stratus';
import { element } from 'angular';
import 'angular-material';
import { hydrate, isJSON, safeUniqueId } from '@stratusjs/core/misc';
import { cookie } from '@stratusjs/core/environment';
import '@stratusjs/angularjs-extras';
const min = !cookie('env') ? '.min' : '';
const packageName = 'idx';
const moduleName = 'member';
const componentName = 'search';
const localDir = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/src/${moduleName}/`;
const localDistStyle = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/dist/${packageName}.bundle.min.css`;
Stratus.Components.IdxMemberSearch = {
    bindings: {
        elementId: '@',
        tokenUrl: '@',
        listId: '@',
        listLinkUrl: '@',
        listLinkTarget: '@',
        options: '<',
        template: '@',
        variableSync: '@'
    },
    controller($attrs, $q, $mdDialog, $scope, Idx) {
        const $ctrl = this;
        $scope.uid = safeUniqueId(packageName, moduleName, componentName);
        $scope.elementId = $attrs.elementId || $scope.uid;
        Stratus.Instances[$scope.elementId] = $scope;
        if ($attrs.tokenUrl) {
            Idx.setTokenURL($attrs.tokenUrl);
        }
        Stratus.Internals.CssLoader(localDistStyle).then();
        this.$onInit = () => {
            var _a;
            var _b;
            $scope.listId = $attrs.listId || null;
            $scope.listInitialized = false;
            $scope.listLinkUrl = $attrs.listLinkUrl || '/property/member/list';
            $scope.listLinkTarget = $attrs.listLinkTarget || '_self';
            $scope.options = hydrate($ctrl.options) || hydrate($attrs.options) || {};
            (_a = (_b = $scope.options).query) !== null && _a !== void 0 ? _a : (_b.query = {});
            if ($scope.options.tokenUrl) {
                Idx.setTokenURL($scope.options.tokenUrl);
            }
            Idx.registerSearchInstance($scope.elementId, moduleName, $scope, $scope.listId);
            if ($scope.listId) {
                Idx.on($scope.listId, 'init', $scope.refreshSearchWidgetOptions);
                Idx.on($scope.listId, 'searching', $scope.refreshSearchWidgetOptions);
            }
            Idx.emit('init', $scope);
        };
        $scope.variableSync = () => __awaiter(this, void 0, void 0, function* () {
            $scope.variableSyncing = $attrs.variableSync && isJSON($attrs.variableSync) ? JSON.parse($attrs.variableSync) : {};
            const promises = [];
            Object.keys($scope.variableSyncing).forEach((elementId) => {
                promises.push($q((resolve) => __awaiter(this, void 0, void 0, function* () {
                    const varElement = Idx.getInput(elementId);
                    if (varElement) {
                        const scopeVarPath = $scope.variableSyncing[elementId];
                        yield Idx.updateScopeValuePath($scope, scopeVarPath, varElement.val());
                        $scope.$watch(scopeVarPath, (value) => {
                            varElement.val(value);
                        }, true);
                    }
                    resolve();
                })));
            });
            yield $q.all(promises);
        });
        $scope.search = $scope.searchMembers = () => {
            let listScope;
            if ($scope.listId) {
                listScope = Idx.getListInstance($scope.listId, 'member');
            }
            if (listScope) {
                $scope.options.query.Page = 1;
                listScope.search($scope.options.query, true).then();
            }
            else {
                console.log('displaying popup');
                $scope.displayMemberSelector();
            }
        };
        $scope.displayMemberSelector = () => {
            $scope.variableSyncing = $attrs.variableSync && isJSON($attrs.variableSync) ? JSON.parse($attrs.variableSync) : {
                agent_fname: 'MemberFirstName',
                agent_lname: 'MemberLastName',
                agent_license: 'MemberStateLicense',
                office_name: 'OfficeName',
                office_id: 'OfficeNumber'
            };
            const templateOptions = {
                options: '',
                template: 'mothership/list.selector',
                'variable-sync': JSON.stringify($scope.variableSyncing)
            };
            if ($scope.options.query) {
                const options = {
                    service: [$scope.options.service || 0],
                    where: $scope.options.query
                };
                options.fields = [
                    '_id',
                    'MemberKey',
                    'MemberStateLicense',
                    'MemberNationalAssociationId',
                    'MemberFirstName',
                    'MemberLastName',
                    'MemberFullName',
                    'MemberEmail',
                    'MemberOfficePhone',
                    'MemberStatus',
                    'MemberMlsAccessYN',
                    'MemberType',
                    'MemberAOR',
                    'OfficeKey',
                    'OfficeMlsId',
                    'OfficeName',
                    'OriginatingSystemName',
                    'SourceSystemName'
                ];
                templateOptions.options = JSON.stringify(options);
            }
            let template = '<md-dialog aria-label="Property Member Selector" class="transparent">' +
                '<md-button style="text-align: center" data-ng-click="close()">Close and Accept</md-button>' +
                '<stratus-idx-member-list ';
            forEach(templateOptions, (optionValue, optionKey) => {
                template += `${optionKey}='${optionValue}'`;
            });
            template +=
                '></stratus-idx-member-list>' +
                    '</md-dialog>';
            $mdDialog.show({
                template,
                parent: element(document.body),
                clickOutsideToClose: true,
                fullscreen: true,
                controller: ($scope, $mdDialog) => {
                    const dc = this;
                    dc.$onInit = () => {
                        dc.close = $scope.close;
                    };
                    $scope.close = () => {
                        console.log('Close clicked!');
                        if ($mdDialog) {
                            console.log('Will close dialog!');
                            $mdDialog.hide();
                        }
                    };
                }
            })
                .then(() => {
            }, () => {
            });
        };
        $scope.refreshSearchWidgetOptions = (listScope) => __awaiter(this, void 0, void 0, function* () {
            if (!listScope &&
                $scope.listId) {
                listScope = Idx.getListInstance($scope.listId, 'Member');
            }
            if (listScope) {
                $scope.listInitialized = true;
            }
        });
        $scope.on = (emitterName, callback) => Idx.on($scope.elementId, emitterName, callback);
        $scope.remove = () => {
        };
    },
    templateUrl: ($attrs) => `${localDir}${$attrs.template || componentName}.component${min}.html`
};

//# sourceMappingURL=search.component.js.map
